const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>How to Speed Up Your Withdrawals</h1>
        <p>
          A few simple checks can significantly accelerate your withdrawal time.
          Keep your account fully verified and aligned, and your funds will move
          with minimal delays.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
